var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNumberShine1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#number-shine-1_svg__filter0_d_13444_90068)",
    clipRule: "evenodd",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.453 7.012h6.223V29h-7.483V17.418c0-.374.003-.74.007-1.096l-2.592 2.14-4.069-5.003 7.914-6.447zm.712 2l-5.813 4.736 1.536 1.889 1.478-1.22c.97-.867 1.864-1.712 2.908-2.505 0 1.837-.08 3.67-.08 5.506V27h3.482V9.012h-3.511z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.453 7.012h6.223V29h-7.483V17.418c0-.374.003-.74.007-1.096l-2.592 2.14-4.069-5.003 7.914-6.447zm.712 2l-5.813 4.736 1.536 1.889 1.478-1.22c.97-.867 1.864-1.712 2.908-2.505 0 1.837-.08 3.67-.08 5.506V27h3.482V9.012h-3.511z",
    stroke: "#02A7DB",
    strokeOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "number-shine-1_svg__filter0_d_13444_90068",
    x: 0.836,
    y: 2.512,
    width: 23.34,
    height: 30.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00784314 0 0 0 0 0.654902 0 0 0 0 0.858824 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13444_90068"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13444_90068",
    result: "shape"
  })))));
}

export default SvgNumberShine1;